import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      paddingTop: '30px',
      width: '100%',
      height: '100%'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    hide: {
      visibility: 'hidden',
    }, 
    flex: {
      display: 'flex',
      alignItems: 'center',
      '&.flex-j-e': {
        justifyContent: 'end',
      },
    },
    baseMenu: {
      '& .MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper.MuiPopover-paper':
      {
        boxShadow: `1px 1px ${colors.color13}30`,
      },
    },
    section: {
      marginBottom: '32px',
    },
    clean: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    headerTable: {
      '&.MuiTableCell-head': {
        minWidth: '100px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    mineHeaderTable: {
      '&.MuiTableCell-head': {
        width: '40px',
      },
      /* '&.MuiTableCell-root.MuiTableCell-root': {
          vertialAlign: 'middle',
      }, */
    },
    areaTitle: {
      fontSize: '12px',
      color: colors.color10,
      display: 'flex',
      alignItems: 'center',
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '14px',
      },
      '&.MuiIcon-root': {
        fontSize: '14px',
        height:'18px',
        width:'18px',
      },
    },
    circle: {
      width: '10px',
      height: '10px',
      backgroundColor: colors.color13,
      borderRadius: '50%',
      marginLeft: 1
    },
    headerTableActions: {
      '&.MuiTableCell-head': {
        minWidth: '50px',
      },
      '&.MuiTableCell-root.MuiTableCell-root': {
        vertialAlign: 'middle',
      },
    },
    containerStatus: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      width: '100%',
      height: '100%',
    },
  }
}

export { useStyles }
